import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
import EFOcats_import_lang from '../import/efocats_import_lang.js';

/**
 * 比較チェッククラス
 */
export default class EFOcats_validate_compare extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    let result = new EFOcats_error_info('success', '', '', '');
    const inputs = checkData.parents('.qa').find("input[type='password'],input[type='text'],input[type='email'],input[type='tel']");

    // 両方に値がある時にチェックを実行
    if (inputs.eq(0).val() && inputs.eq(1).val()) {
      if (inputs.eq(0).val() !== inputs.eq(1).val()) {
        result = new EFOcats_error_info('error', EFOcats_import_lang.getValue('compareError'), '', EFOcats_import_lang.getValue('compareError'));
      }
    }

    return result;
  }
}
